import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para todas las edades?',
    a: 'Sí. El pack está organizado por franjas de edad (2-5, 6-8 y 9-12 años) para que cada actividad sea apropiada y efectiva para el nivel de desarrollo de tu hijo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. Una vez confirmado el pago, recibís un mail en soportebibliodigital@gmail.com con el link de descarga. En menos de 5 minutos tenés todo.'
  }, {
    q: '¿Qué lo diferencia de lo que encuentro gratis en internet?',
    a: 'El material gratuito son ideas sueltas. Esto es un sistema completo con orden, progresión y herramientas de emergencia para cuando las cosas se ponen difíciles. La diferencia es la misma que entre una receta suelta y un libro de cocina profesional.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas. Si no te sirve, te devolvemos el 100%. Así de simple.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: 'No. Todo lo que necesitás se consigue en cualquier kiosco, súper o ferretería argentina. Sin gastos extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-dark-800 py-20 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#FFF8F0]" data-id="element-88">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, i) => <div key={i} className="bg-dark-900 border border-primary/20 rounded-2xl overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-91">
                <span className="font-bold text-cream text-lg pr-4" data-id="element-92">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-primary transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="px-6 pb-5 text-cream/80 border-t border-primary/10 pt-4" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}